import React from "react";

import { useWrapExperienceCardContext } from "./WrapExperienceContext";
import WrapExperienceText from "./WrapExperienceText";

const WrapExperienceAuthor = () => {
  const { card } = useWrapExperienceCardContext();
  return (
    <WrapExperienceText className={card.author ? "" : "invisible"}>
      Created by {card.author}
    </WrapExperienceText>
  );
};

export default WrapExperienceAuthor;
